import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';

const field = 'w-full px-3 py-2 text-sm border border-slate-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400';
const lbl = 'flex flex-col gap-1.5 text-xs font-semibold uppercase tracking-wider text-slate-500';
const EMPTY = { cliente: '', tipo: 'bano', cantidad: '', fechaFactura: '', fechaAbono: '', notas: '' };

export const NuevoPedidoDialog = ({ open, onOpenChange, params, onCreate, initial }) => {
  const [f, setF] = useState(() => (initial ? { ...EMPTY, ...initial, cantidad: String(initial.cantidad) } : EMPTY));
  const [err, setErr] = useState('');
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (!f.cliente.trim() || !f.fechaAbono || !(+f.cantidad > 0)) { setErr('Falta cliente, cantidad o fecha del primer abono'); return; }
    const { cliente, tipo, cantidad, fechaFactura, fechaAbono, notas } = f;
    await onCreate({ cliente: cliente.trim(), tipo, cantidad: +cantidad, fechaFactura: fechaFactura || '', fechaAbono, notas: notas || '' });
    if (!initial) setF({ ...EMPTY, tipo: f.tipo });
    setErr('');
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg bg-white" data-testid="nuevo-pedido-dialog">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">{initial ? 'Editar pedido' : 'Nuevo pedido'}</DialogTitle>
          <DialogDescription>El plan de producción se calcula desde el primer abono, en días hábiles.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="grid grid-cols-2 gap-4">
          <label className={`${lbl} col-span-2`}>Cliente<input data-testid="input-cliente" className={field} value={f.cliente} onChange={set('cliente')} placeholder="Nombre del cliente o empresa" /></label>
          <label className={lbl}>Tipo
            <select data-testid="select-tipo" className={field} value={f.tipo} onChange={set('tipo')}>
              {Object.keys(params).map((k) => <option key={k} value={k}>{params[k].n}</option>)}
            </select>
          </label>
          <label className={lbl}>Cantidad ({params[f.tipo]?.u})<input data-testid="input-cantidad" type="number" min="0" step="any" className={field} value={f.cantidad} onChange={set('cantidad')} /></label>
          <label className={lbl}>Fecha de facturación<input data-testid="input-fecha-factura" type="date" className={field} value={f.fechaFactura} onChange={set('fechaFactura')} /></label>
          <label className={lbl}>Fecha del primer abono<input data-testid="input-fecha-abono" type="date" className={field} value={f.fechaAbono} onChange={set('fechaAbono')} /></label>
          <label className={`${lbl} col-span-2`}>Notas<textarea data-testid="input-notas" rows={2} className={field} value={f.notas} onChange={set('notas')} placeholder="Material, color, herrajes..." /></label>
          {err ? <p data-testid="nuevo-pedido-error" className="col-span-2 text-sm text-red-600 font-medium">{err}</p> : null}
          <button type="submit" data-testid="btn-guardar-pedido" className="col-span-2 py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white font-semibold transition-colors">{initial ? 'Guardar cambios' : 'Guardar pedido'}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
